// src/components/Footer.js
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { localePath } from "../utils/content";
import BrandLogo from "./BrandLogo";
import caciPng from "../assets/logo-caci.png";
import caciWebp from "../assets/logo-caci.webp";

export default function Footer() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const year = new Date().getFullYear();

  return (
    <footer className="dajc-footer">
      <div className="container">
        <div className="dajc-footer__top">
          <div className="dajc-footer__brand">
            <div className="dajc-footer__logos">
              <BrandLogo lang={lang} className="dajc-footer__logo" />
              <span className="dajc-footer__logos-sep" aria-hidden="true" />
              <a
                href="https://www.caci.dz"
                target="_blank"
                rel="noopener noreferrer"
                className="dajc-footer__caci"
                aria-label={t("footer.caci_link")}
              >
                <picture>
                  <source srcSet={caciWebp} type="image/webp" />
                  <img src={caciPng} alt="" width="256" height="256" loading="lazy" decoding="async" />
                </picture>
              </a>
            </div>
            <div className="name">{t("brand.short")}</div>
            <div className="sub">{t("brand.parent")}</div>
            <p>{t("footer.about_text")}</p>
            <div className="dajc-footer__socials">
              <a href="#!"  aria-label="LinkedIn"><i className="bi bi-linkedin" /></a>
              <a href="#!" aria-label="Facebook"><i className="bi bi-facebook" /></a>
              <a href="#!" aria-label="Twitter"><i className="bi bi-twitter-x" /></a>
              <a href="#!" aria-label="YouTube"><i className="bi bi-youtube" /></a>
            </div>
          </div>

          <div>
            <h5>{t("footer.links_title")}</h5>
            <ul>
              <li><Link to={localePath(lang)}>{t("menu.home")}</Link></li>
              <li><Link to={localePath(lang, "about")}>{t("menu.about")}</Link></li>
              <li><Link to={localePath(lang, "publications")}>{t("menu.publications")}</Link></li>
              <li><Link to={localePath(lang, "ressources")}>{t("menu.ressources")}</Link></li>
              <li><Link to={localePath(lang, "contact")}>{t("menu.contact")}</Link></li>
            </ul>
          </div>

          <div>
            <h5>{t("footer.ccma_title")}</h5>
            <ul>
              <li><Link to={localePath(lang, "page/12")}>{t("ccma.pages.presentation")}</Link></li>
              <li><Link to={localePath(lang, "page/15")}>{t("ccma.pages.legal_framework")}</Link></li>
              <li><Link to={localePath(lang, "page/17")}>{t("ccma.pages.referral")}</Link></li>
              <li><Link to={localePath(lang, "page/18")}>{t("ccma.pages.arbitration_rules")}</Link></li>
              <li><Link to={localePath(lang, "page/2")}>{t("ccma.pages.arbitration_request")}</Link></li>
              <li><Link to={localePath(lang, "page/21")}>{t("ccma.pages.conciliation_mediation")}</Link></li>
            </ul>
          </div>

          <div>
            <h5>{t("footer.contact_title")}</h5>
            <div className="dajc-footer__contact-row">
              <i className="bi bi-geo-alt" />
              <span>{t("contact.address")}</span>
            </div>
            <div className="dajc-footer__contact-row">
              <i className="bi bi-envelope" />
              <a href={`mailto:${t("contact.email_site")}`} style={{ color: "inherit" }}>{t("contact.email_site")}</a>
            </div>
            <div className="dajc-footer__contact-row">
              <i className="bi bi-telephone" />
              <span><bdi>{t("contact.phone")}</bdi></span>
            </div>
          </div>
        </div>

        <div className="dajc-footer__bottom">
          <div>© {year} {t("brand.full")} — {t("footer.rights")}</div>
          <div>
            <a href="https://www.caci.dz" target="_blank" rel="noopener noreferrer">{t("footer.caci_link")}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}